@if (label() && showLabel()) {
  <app-form-label [label]="label()" />
}

@if (enableViewMode()) {
  <div #richTextContainer>
    <quill-view
      (onEditorCreated)="onQuillViewCreated()"
      [content]="control().value"
      [class.expanded]="isExpanded()"
      format="html"
    ></quill-view>
    @if (hasMoreContent()) {
      <div class="blue-link show-btn" (click)="isExpanded.set(!isExpanded())">
        {{ isExpanded() ? translations.showLess : translations.showMore }}
      </div>
    }
  </div>
} @else {
  <quill-editor
    bounds="self"
    [formControl]="control()"
    [placeholder]="placeholder()"
    [readOnly]="control().disabled"
    (onEditorCreated)="onQuillEditorCreated()"
  />

  <app-form-hint
    [isOptional]="isOptional()"
    [hint]="hint()"
    [isDisabled]="control().disabled"
    [errors]="control().errors"
    [showError]="control().errors && (control().dirty || control().touched)"
  />
}
